import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const nrAccountId = import.meta.env.VITE_NEW_RELIC_ACCOUNT_ID
const nrLicenseKey = import.meta.env.VITE_NEW_RELIC_LICENSE_KEY
const nrApplicationId = import.meta.env.VITE_NEW_RELIC_APPLICATION_ID
const nrAgentId = import.meta.env.VITE_NEW_RELIC_AGENT_ID
const nrTrustKey = import.meta.env.VITE_NEW_RELIC_TRUST_KEY

if (nrAccountId && nrLicenseKey && nrApplicationId) {
  import('@newrelic/browser-agent/loaders/browser-agent').then(({ BrowserAgent }) => {
    new BrowserAgent({
      init: {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.nr-data.net'] },
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: nrLicenseKey,
        applicationID: nrApplicationId,
        sa: 1,
      },
      loader_config: {
        accountID: nrAccountId,
        trustKey: nrTrustKey || nrAccountId,
        agentID: nrAgentId || nrApplicationId,
        licenseKey: nrLicenseKey,
        applicationID: nrApplicationId,
      },
    })
  })
}

if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.MODE !== 'development') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

// Detect Android TV WebView and add class before React renders (for CSS)
if (/Android/.test(navigator.userAgent) && /wv\)/.test(navigator.userAgent)) {
  document.body.classList.add('android-tv');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
